import { bootstrap } from 'angular';
import 'ricola3';
import ngResource from 'angular-resource';
import uiRouter from 'angular-ui-router';

import App from './app/';
import CreditRequest from './credit-request/';

const app = angular.module('webPublicClient', [
  'rc',
  ngResource,
  uiRouter,
  App.name,
  CreditRequest.name
]);

bootstrap(document.body, [app.name], {
  strictDi: true
});

export default app.name;



// WEBPACK FOOTER //
// ./src/index.js